<template>
  <section id="hero">
    <video-background
      class="video"
      :poster="require('@/assets/featured-1.png')"
      style="max-height: 100vh; height: 100vh; z-index: 1;"
    />
    <!-- <div class="gradient" /> -->
    <!-- <div class="heading">
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="700"
          width="100%"
        >
          <v-fade-transition leave-absolute>
            <span :key="selectedTitle">
              <base-heading :title="titles[selectedTitle]" />
            </span>
          </v-fade-transition>

          <base-body>
            With the latest in mask animation technology
          </base-body>
        </v-responsive>
      </v-container>
    </div> -->
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    data () {
      return {
        overlay: true,
        selectedTitle: 0,
        titles: [
          'BE THE LIFE OF THE PARTY',
          'STAYING SAFE',
          'TURNING HEADS',
          'EXPRESS YOURSELF',
        ],
      }
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },

    mounted () {
      setInterval(() => {
        this.selectedTitle += 1

        if (this.selectedTitle >= this.titles.length) {
          this.selectedTitle = 0
        }
      }, 5000)
    },
  }
</script>

<style scoped>
.gradient {
  background-image: linear-gradient(
    to right,
    rgba(5, 11, 31, 0.4),
    rgba(5, 11, 31, 0.2)
  );
  width: 100%;
  height: 100vh;
  min-height: 600px;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}

.heading {
  position: absolute;
  top: 0;
  z-index: 3;
  width: 100%;
  height: 100vh;
  min-height: 600px;
}
</style>
